export const LEGAL_VERSIONS = {
  terms: "1.0",
  privacy: "1.0",
  acceptable_use: "1.0",
  effective_date: "June 1, 2026",
  last_updated: "June 1, 2026",
};

export const PLACEHOLDERS = {
  entity: "FindRxStaff",
  email: "contact@findrxstaff.com",
  support: "contact@findrxstaff.com",
};

export const PROHIBITED_INFORMATION = [
  "Patient names or any patient identifiers",
  "Patient medical information or Protected Health Information (PHI)",
  "Prescriptions or prescription images",
  "Medical records",
  "Insurance information",
  "Social Security numbers",
  "Passwords or authentication codes",
  "Banking, credit card or other financial account information",
  "Controlled-substance information",
  "Confidential or proprietary pharmacy business information",
  "Any other sensitive information that is not necessary for staffing coordination",
];

export const CONSENT_ITEMS = [
  { key: "accept_terms", label: "I agree to the FindRxStaff Terms of Use.", link: "/legal/terms" },
  { key: "accept_privacy", label: "I have reviewed the FindRxStaff Privacy Policy.", link: "/legal/privacy" },
  {
    key: "ack_not_employer",
    label:
      "I understand that FindRxStaff is a connection platform and does not automatically employ, supervise, or pay me.",
  },
  {
    key: "ack_verify_other_party",
    label:
      "I understand that I am responsible for independently verifying the other party, including qualifications, compensation, schedule, and working arrangements.",
  },
  {
    key: "ack_no_confidential_info",
    label:
      "I will not submit patient information, PHI, prescriptions, passwords, financial account information, Social Security numbers, or other confidential information to FindRxStaff.",
  },
];

export const EMPTY_CONSENT = CONSENT_ITEMS.reduce((acc, i) => ({ ...acc, [i.key]: false }), {});
